import React, { Component } from 'react';

// import { getRandom } from '../../../utils/numbers.js'

import './Shutter.css'

class Shutter extends Component {

    // shouldComponentUpdate(nextProps, nextState) {

    //     if (this.props.isReady !== nextProps.isReady) {
    //         return true;
    //     }
        
    //     return false;
    // }

    render() {

        const { isReady, size, color, height } = this.props
        const delay = 0.075

        const total = Math.ceil(size.height / height)


        let slates = []
        let opacity = 1

        for (var i = 0; i < total; i++) {

            const slateStlye = {
                // opacity: isReady ? 1 : 0,
                top: i * height,
                height: height,
                opacity: isReady ? opacity : 0,
                transitionDelay: isReady ? `${delay * i}s` : 0,
                transform: isReady ? `scaleX(1)` : 'scaleX(0)',
                background: color
            }


            slates.push(<div key={i} className="slate" style={slateStlye}></div>)
        }



        return (
            <div className="shutter">

                {slates}

            </div>
        );
    }
}

export default Shutter;